import { useQuery } from "@tanstack/react-query";

// import { preCourseAssessmentKeys } from "../../../../redux/services/preCourseAssessment";
import { getPostChapterAssessmentQuestionApiCall } from "./utils.api";
import { postChapterAssessmentKeys } from "../../../../redux/services/postChapterAssessment";

// import { getPreAssessmentQuestionApiCall } from "./utils.api";

export const useGetPostChapterAssessmentQuestion = (payload) =>{
    const {courseId, moduleId , chapterId  , languageid}= payload;

    return useQuery({
        queryKey: postChapterAssessmentKeys.getPostChapterAssessmentKeys({courseId, moduleId , chapterId  , languageid}),
        queryFn: () => getPostChapterAssessmentQuestionApiCall({courseId, moduleId , chapterId  , languageid}),
    });
}